import React from 'react';
import ProductOpinion from 'components/product/product-opinion/product-opinion';
import { OpinionsItemsInterface } from 'interfaces/opinions.interface';
import Link from 'atomic/utilization/link';

import './product-opinion-list.scss';

interface OpinionListProps {
    url: string;
    count: number;
    items: OpinionsItemsInterface[];
}

const ProductOpinionList: React.FC<OpinionListProps> = ({ url, count, items }) => (
    <ul className="opinion-list">
        {
            items.map(({ rating, author, content, timestamp }, index) => (
                <li key={index} className="opinion-list__item">
                    <ProductOpinion rating={rating} author={author} content={content}
                        timestamp={timestamp}
                    />
                </li>
            ))
        }
        {
            count > items.length && (
                <li className="opinion-list__item opinion-list__item--button">
                    <Link
                        href={url}
                        className="opinion-list__button"
                        type="button"
                        color="blue"
                        size="md"
                        uppercase={true}
                    >
                        zobacz więcej
                    </Link>
                </li>
            )
        }
    </ul>
);

export default ProductOpinionList;
